import Box from '@mui/material/Box';
import { useIsMobile } from '@repo/mui-config/hooks';
import { ModalHeader, Modal } from '@repo/ui';

import type { ModalProps } from '../display-modal';
import { ModalContent } from '../modal-content';

export function ModalLoanActionCard({ modalState, isModalOpen, closeModal }: ModalProps) {
  const isMobile = useIsMobile();

  return (
    <Modal
      slotProps={{
        paper: {
          sx: {
            borderRadius: '10px',
            position: 'absolute',
          },
        },
      }}
      isOpen={isModalOpen}
      maxWidth="xs"
    >
      <Box sx={{ pt: 6, pb: 4, px: isMobile ? 2 : 4 }}>
        <ModalHeader centeredLogo closeButton={{ isVisible: true, onClick: closeModal }} />
        <ModalContent modalType={modalState} />
      </Box>
    </Modal>
  );
}
